import { FetchResult } from 'apollo-boost'

export interface HandleFetchResultProps<P, O> {
  handler: (data: P) => O
  name?: string
}

export type HandleFetchResultReturn<P, O> = (result: FetchResult<P>) => O

function handleFetchResult<P, O>({
  handler,
  name,
}: HandleFetchResultProps<P, O>): HandleFetchResultReturn<P, O> {
  return (result: FetchResult<P>) => {
    if (result.data) return handler(result.data)
    if (result.errors) throw new Error(result.errors[0].message)
    throw new Error('Failed to update' + name ? ` ${name}` : '')
  }
}

export default handleFetchResult
